import React, { useState, useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import './App.css';
import LeaveForm from './components/LeaveForm';
import ReasonDisplay from './components/ReasonDisplay';
import Header from './components/Header';
import ThemeSwitcher from './components/ThemeSwitcher';
import { generateReason, options } from './reasons';

function App() {
  const [showResult, setShowResult] = useState(false);
  const [formData, setFormData] = useState(null);
  const [reason, setReason] = useState('');
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    document.body.className = theme + '-theme';
  }, [theme]);

  const handleGenerate = (data) => {
    setFormData(data);
    const newReason = generateReason(data);
    setReason(newReason);
    setShowResult(true);
  };

  const handleRegenerate = () => {
    const newReason = generateReason(formData);
    setReason(newReason);
  };

  const handleChangeStyle = (newStyle) => {
    const newFormData = { ...formData, style: newStyle };
    setFormData(newFormData);
    const newReason = generateReason(newFormData);
    setReason(newReason);
  };

  const handleBack = () => {
    setShowResult(false);
  };

  const transitions = useTransition(showResult, {
    from: { opacity: 0, transform: 'translate3d(0, 40px, 0)', position: 'absolute', width: '100%' },
    enter: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
    leave: { opacity: 0, transform: 'translate3d(0, -40px, 0)' },
  });

  return (
    <div className="App">
      <ThemeSwitcher theme={theme} toggleTheme={toggleTheme} />
      <Header />
      <div className="content-container">
        {transitions((styles, item) =>
          item ? (
            <animated.div style={styles}>
              <ReasonDisplay
                reason={reason}
                currentStyle={formData.style}
                styles={options.styles}
                onChangeStyle={handleChangeStyle}
                onRegenerate={handleRegenerate}
                onBack={handleBack}
              />
            </animated.div>
          ) : (
            <animated.div style={styles}>
              <LeaveForm onGenerate={handleGenerate} />
            </animated.div>
          )
        )}
      </div>
    </div>
  );
}

export default App;
